import React from 'react';

import { Container } from './AccountItem.styles';

export type AccountItemProps = {
  selected: boolean;
  onClick?: () => void;
};

export const AccountItem: React.FC<AccountItemProps> = ({ children, selected, onClick }) => {
  return (
    <Container selected={selected} data-testid="account-item" onClick={onClick} role="button">
      {children}
    </Container>
  );
};
